import {Component} from '@angular/core';
import {formatCurrency} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';

export interface Commission {
  type: string;
  percentage: number;
}

@Component({
             selector: 'app-detail-table',
             templateUrl: './commission-table.component.html',
             styleUrls: ['../../detail-screen/detail-screen.component.css'],
           })
export class CommissionTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: Commission[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor(public dialog: MatDialog) {
    this.tableColumns = [];
    this.tableData = [];
  }

  getAmount(value, currency: string) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatCurrency(value, 'nl', '€', currency);
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
}
